"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../types/utils");
var genericConstraintError_1 = __importDefault(require("./genericConstraintError"));
var formatter_1 = require("../types/formatter");
var checker_1 = require("../types/checker");
/**
 * Combines multiple value types in the manner specified by the generic parameters from a function signature.
 */
var GenericConstraintSolver = /** @class */ (function () {
    function GenericConstraintSolver(identifier) {
        this.constraints = new Map();
        this.resolved = null;
        this.identifier = identifier;
    }
    Object.defineProperty(GenericConstraintSolver.prototype, "resolvedType", {
        get: function () {
            return this.resolved;
        },
        enumerable: false,
        configurable: true
    });
    GenericConstraintSolver.prototype.addConstraint = function (generic, type) {
        if (this.constraints.has(generic.combiner)) {
            this.constraints.get(generic.combiner).push(type);
        }
        else {
            this.constraints.set(generic.combiner, [type]);
        }
    };
    GenericConstraintSolver.prototype.resolveType = function () {
        if (this.constraints.size === 0) {
            throw new genericConstraintError_1.default("Cannot resolve generic type without any constraints");
        }
        this.resolved = null;
        if (this.constraints.has("set")) {
            for (var _i = 0, _a = this.constraints.get("set"); _i < _a.length; _i++) {
                var type = _a[_i];
                if (this.resolved === null) {
                    this.resolved = type;
                }
                else if (!checker_1.typeMatchesType(type, this.resolved)) {
                    // If the new type does not match the existing resolved type, but it does match when primitive values are ignored,
                    // the existing and new types are of the same underlying type but with different values. This is allowed,
                    // so we change the resolved type to be the value-less primitive type.
                    if (utils_1.isPrimitiveType(this.resolved) && checker_1.typeMatchesType(type, this.resolved, false)) {
                        this.resolved = { type: this.resolved.type };
                    }
                    else {
                        throw new genericConstraintError_1.default("Cannot resolve generic constraint " + this.identifier + ". Type " + formatter_1.formatType(type) + " is incompatible with existing type " + formatter_1.formatType(this.resolved));
                    }
                }
            }
        }
        if (this.constraints.has("formUnion")) {
            var options = this.constraints.get("formUnion");
            if (this.resolved) {
                options.push(this.resolved);
            }
            options = utils_1.mergeTypes(options);
            if (options.length === 1) {
                this.resolved = options[0];
            }
            else {
                this.resolved = { type: "union", options: options };
            }
        }
    };
    return GenericConstraintSolver;
}());
exports.default = GenericConstraintSolver;
//# sourceMappingURL=genericConstraintSolver.js.map